import { RESET_BANK_DATA, SET_BANK_DATA, SET_BANK_DATA_NOT_ALLOWED, SET_BANK_DATA_REQUEST_STATUS } from '../../actionTypes/bankData'
import { REQUEST_STATUS } from '../../../component/BankData/constants'

const initialState = {
	bankData: null,
	isNotAllowed: false,
	requestStatus: REQUEST_STATUS.IDLE,
}

export function bankDataReducer (state = initialState, action) {
	switch (action.type) {
		case SET_BANK_DATA:
			return {
				...state,
				bankData: action.value,
			}
		case SET_BANK_DATA_NOT_ALLOWED:
			return {
				...state,
				isNotAllowed: action.value,
			}
		case SET_BANK_DATA_REQUEST_STATUS:
			return {
				...state,
				requestStatus: action.value,
			}
		case RESET_BANK_DATA:
			return initialState
		default:
			return state
	}
}
